import React from "react"
import {useRoomSetup, useLocal} from "../AppContext"

export const RoomSize = () => {
    const local = useLocal()
    const roomSetup = useRoomSetup()
    const dimensions = roomSetup.getDimensions()

    let q2 = 0
    let q3 = 0

    switch (roomSetup.getShape()) {
        case "rectangle":
            q2 = dimensions.a * dimensions.b
            q3 = q2 * dimensions.height
            break
        case "open":
            q2 = dimensions.a * .5 * (dimensions.b + dimensions.c)
            q3 = q2 * dimensions.height
            break
        case "l_form_a":
            q2 = dimensions.c * dimensions.c - ((dimensions.c - dimensions.a) * (dimensions.d - dimensions.b))
            q3 = q2 * dimensions.height
            break
        case "l_form_b":
            q2 = dimensions.b * dimensions.c - ((dimensions.c - dimensions.a) * (dimensions.b - dimensions.d))
            q3 = q2 * dimensions.height
            break
        case "l_form_c":
            q2 = dimensions.a * dimensions.d - ((dimensions.a - dimensions.c) * (dimensions.d - dimensions.b))
            q3 = q2 * dimensions.height
            break
        case "l_form_d":
            q2 = dimensions.a * dimensions.b - ((dimensions.a - dimensions.c) * (dimensions.b - dimensions.d))
            q3 = q2 * dimensions.height
            break
        case "pentagonal_a":
            q2 = dimensions.c * dimensions.c - .5 * ((dimensions.c - dimensions.a) * (dimensions.d - dimensions.b))
            q3 = q2 * dimensions.height
            break
        case "pentagonal_b":
            q2 = dimensions.b * dimensions.c - .5 * ((dimensions.c - dimensions.a) * (dimensions.b - dimensions.d))
            q3 = q2 * dimensions.height
            break
        case "pentagonal_c":
            q2 = dimensions.a * dimensions.d - .5 * ((dimensions.a - dimensions.c) * (dimensions.d - dimensions.b))
            q3 = q2 * dimensions.height
            break
        case "pentagonal_d":
            q2 = dimensions.a * dimensions.b - .5 * ((dimensions.a - dimensions.c) * (dimensions.b - dimensions.d))
            q3 = q2 * dimensions.height
            break
    }

    q2 = q2 / (100 * 100)
    q3 = q3 / (100 * 100 * 100)

    return local.decimal(q2) + " m² / " + local.decimal(q3) + " m³"
}
